import React, { useState, useEffect } from "react";
import axios from "axios";
import { getToken, getUser } from "../../../Utils/Common";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setUserCredits } from "../../../features/counter/counterSlice";

function DiscountSuccess(props) {
  const [error, setError] = useState([]);
  const [payment, setPayment] = useState({});
  const [message, setMessage] = useState("");
  const dispatch = useDispatch();

  // const id = useParams();
  const navigate = useNavigate();
  const { id } = useParams();
  const token = getToken();

  useEffect(() => {
    //Check to see if this is a redirect back from Checkout
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}v1/user/retrieve-discount/${id}`,
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      // data: {
      //     price: "price_1KhY8bHuNOGPY9jaCIulrQ90",
      // },
    })
      .then((response) => {
        if (response.status === 200) {
          console.log(response.data);
          setPayment(response.data);
          // setUserSession(token, response.data.user);
          localStorage.setItem("thanks message", response.data.message);
          dispatch(setUserCredits(response.data.user));
          navigate("/lingostory");
          // window.location.href("/library");
        }
      })
      .catch((error) => {
        if (error.response.status === 500) {
          console.log(error.response);
        } else if (error.response.status === 401) {
          console.log(error.response);
        } else if (error.response.status === 422) {
          console.log(error.response.data.message);
          setMessage(error.response.data.message);
        } else {
        }
      });
  }, []);

  return <div style={{ marginTop: "180px" }}>Discount Success Page</div>;
}

export default DiscountSuccess;
